import styled from "styled-components";

export const HeaderSearchListSection = styled.div`
  width: 400px;
  background-color: ${({ theme }) => theme.itemBg};
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 12px;
  padding: 12px;
  box-shadow: ${({ theme }) =>
    theme.theme === 'dark'
      ? '0 8px 24px rgba(0, 0, 0, 0.5)'
      : '0 8px 24px rgba(0, 0, 0, 0.15)'
  };
  border: 1px solid ${({ theme }) =>
    theme.theme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)'
  };
  z-index: 1000;
`;
